export const enabledDisabledOptions = [
    { label: "Desabilitado", value: 0 },
    { label: "Habilitado", value: 1 },
]